import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Box } from '@mui/material'
import {
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { RootState } from 'redux/store'

import { PRIMARY_BLUE, PRIMARY_RED } from 'utils/customizedTheme'
import BoxTitle from 'components/atoms/BoxTitle'
import { HowToReg } from '@mui/icons-material'
import { useGET_plopStatsQuery } from 'redux/api/plopApi'

interface IProps{
  student?: number
}

const PlopStats: FC<IProps> = ({student}) => {
  const { t } = useTranslation()
  const reduxKey = 'dashboard'

  const filters = {}
  const date_after=useSelector((state: RootState) => state[reduxKey].date_after)
  const date_before=useSelector((state: RootState) => state[reduxKey].date_before)

  if(student)filters["student"]=student
  if(date_after)filters["date_after"]=date_after
  if(date_before)filters["date_before"]=date_before

  const { data } = useGET_plopStatsQuery(filters)

  const labelByCategory = {
    avg_score: t('common.average-score'),
    baseline_percentage: t('common.baseline-percentage')
  }
  
  const formatter = (value, name, props) => { 
    let formattedName = labelByCategory[name] 
    let formattedValue = Math.round(value * 100) / 100
    return [formattedValue, formattedName, props] 
  }

  return (
    <Box className="thick-border" sx={{ height: '350px' }}> { data && <>
      <BoxTitle title={ t('common.average-level-of-performance') } icon={<HowToReg />} />
      <div style={{ height: '20px' }} />
      <ResponsiveContainer width='100%' height='90%'>
        <LineChart
          data={data.map(m => { return {...m, baseline_percentage: 51} }).slice(-6)}
          margin={{
            bottom: 20,
            right: 20
          }}
        >
          <XAxis dataKey='month' interval={0} tick={<CustomizedAxisTick />} />
          <YAxis />
          <Tooltip formatter={formatter} />
          <ReferenceLine y={100} />

          <Line
            type='monotone'
            dataKey='avg_score'
            stroke={PRIMARY_BLUE}
            strokeWidth={2}
            activeDot={{ r: 2 }}
            label={<CustomizedLabel />}
          />

          <Line
            type='monotone'
            dataKey='baseline_percentage'
            stroke={PRIMARY_RED}
            strokeWidth={1}
            activeDot={{ r: 2 }}
            label={<CustomizedLabel />}
          />

        </LineChart>
      </ResponsiveContainer>
    </> }</Box>
  )
}

export default PlopStats

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value} %`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}